export default __webpack_public_path__ + "5275df83d97e75835ac1c34a6cfe4af2.png";